import "./navigation.css";

interface Props {
  onOpen: () => void;
}

export const Navigation = ({ onOpen }: Props) => (
  <nav className="nav">
    <span className="nav-title">FEI</span>
    <button onClick={onOpen} aria-haspopup="dialog" className="nav-btn">
      Information
    </button>
  </nav>
);
